import { useQuery } from '@tanstack/react-query';
import { IGetDashboardJobsParams } from '../dashboardJobsApi';
import {
  DASHBOARD_QUERY_TIMING,
  DASHBOARD_REFRESH_INTERVAL_MS,
} from '../dashboardJobsConstants';
import { dashboardJobsService } from '../dashboardJobsService';
import { IDashboardJob } from '../dashboardJobsTypes';

export function useGetDashboardJobs(params: IGetDashboardJobsParams) {
  const query = useQuery<IDashboardJob[]>({
    queryKey: ['dashboard-jobs', params],
    queryFn: () => dashboardJobsService.getDashboardJobs(params),
    ...DASHBOARD_QUERY_TIMING,
    // Shared with useGetDashboardJobInfo so the badge and the list it labels cannot
    // drift apart — see the constant for why they have to move together.
    refetchInterval: DASHBOARD_REFRESH_INTERVAL_MS,
  });

  return {
    ...query,
    data: query.data ?? [],
  };
}
